import { Link as MultibrandLink } from '@vgw/multibrand-fe-link'
import { Trans, useLingui } from '@lingui/react/macro'

export const LicenseDetails = () => {
  const { t } = useLingui()

  return (
    <p
      className="max-w-(--breakpoint-xl) text-content-variant lg:text-center xl:m-auto"
      title="License Details"
    >
      <Trans>
        Copyright © 2002-{{ currentYear: new Date().getFullYear() }} VGW Group.
        All rights reserved. Chumba Casino is owned and operated by VGW Malta
        Limited. All payments are processed by VGW Malta Limited. The
        sweepstakes promotions and prizes offered at Chumba Casino are operated
        by VGW Games Limited. The registered address of VGW Games Limited is
        Trident Park, Notabile Gardens, No. 6, Level 3, Central Business
        District, Mdina Road, Zone 2 Birkirkara, CBD2010, Malta. VGW Games
        Limited is regulated and licensed by Malta Gaming Authority (MGA). This
        public regulatory authority is responsible for the supervision of all
        kinds of gaming activities that are based in Malta. VGW Games Limited
        holds licence{' '}
        <MultibrandLink
          size="xs"
          weight="bold"
          target="_blank"
          rel="noopener"
          href="https://authorisation.mga.org.mt/verification.aspx?lang=EN&company=4debab56-21d5-49fd-96c5-1c2b5500dbb4&details=1"
          aria-label={t`Read Malta Gaming Authority document to learn more`}
          title={t`Read Malta Gaming Authority document to learn more`}
        >
          MGA/B2C/188/2010
        </MultibrandLink>{' '}
        issued on the 14th August 2017.
      </Trans>
    </p>
  )
}
